import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CuotasComponent } from './cuotas/cuotas.component';
import { ReportesComponent } from './reportes/reportes.component';

const routes: Routes = [
  { path: 'cambiar', component: CuotasComponent },
  { path: 'reportes', component: ReportesComponent },
  { path: '', redirectTo: 'cambiar', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CuotasRoutingModule {}
